import BoldSmallText from '@/components/BoldSmallText';
import { TemplateColors } from '@/constants/enum';
import { templateColors } from '@/constants/template';
import { capitalizeFirstLetter } from '@/helpers/string';
import TemplateCard from '@/pages/Settings/Components/Appearance/components/TemplateCard';
import { dataSettingsSelector } from '@/redux/slice/settings.slice';
import { Button, Collapsible, InlineGrid } from '@shopify/polaris';
import { memo, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

interface IProps {
  handleSelectTemplate: (data: { background_color: string; border_color: string; icon_color: string }) => void;
}
const Template = ({ handleSelectTemplate }: IProps) => {
  const [selectedTemplated, setSelectedTemplated] = useState<TemplateColors | undefined>(TemplateColors.WHITE);
  const [expanded, setExpanded] = useState(false);
  const dataSettings = useSelector(dataSettingsSelector);

  useEffect(() => {
    const templates = [...templateColors.default, ...templateColors.rest];
    const key = templates
      .find(
        (template) =>
          template.background_color === dataSettings.background_color &&
          template.icon_color === dataSettings.icon_color &&
          template.border_color === dataSettings.border_color &&
          template.text_color === dataSettings.text_color,
      )
      ?.key?.toUpperCase();
    const defaultColorKeys = templateColors.default.map((item) => item.key.toUpperCase());
    if (key && !defaultColorKeys.includes(key)) setExpanded(true);
    setSelectedTemplated(TemplateColors[key as keyof typeof TemplateColors] || undefined);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(dataSettings)]);
  return (
    <>
      <BoldSmallText>Theme templates</BoldSmallText>
      <div className="d-flex flex-column">
        <div className="mt-8 w-full">
          <InlineGrid gap="300" columns={{ xs: 1, sm: 2, md: 4 }}>
            {templateColors.default.map((item) => (
              <TemplateCard
                key={item.key}
                text={capitalizeFirstLetter(item.key)}
                backgroundColor={item.background_color}
                borderColor={item.border_color}
                iconColor={item.icon_color}
                borderDashed={item.key === TemplateColors.CLEAR}
                isSelected={selectedTemplated === item.key}
                handleClick={() => {
                  setSelectedTemplated(item.key);
                  handleSelectTemplate(item);
                }}
              />
            ))}
          </InlineGrid>
        </div>
        <Collapsible id="template-collapsible" open={expanded}>
          <div className="mt-12">
            <InlineGrid gap="300" columns={{ xs: 1, sm: 2, md: 4 }}>
              {templateColors.rest.map((item) => (
                <TemplateCard
                  key={item.key}
                  text={capitalizeFirstLetter(item.key)}
                  backgroundColor={item.background_color}
                  borderColor={item.border_color}
                  iconColor={item.icon_color}
                  isSelected={selectedTemplated === item.key}
                  handleClick={() => {
                    setSelectedTemplated(item.key);
                    handleSelectTemplate(item);
                  }}
                />
              ))}
            </InlineGrid>
          </div>
        </Collapsible>
        <div className="mt-8">
          <Button variant="plain" textAlign="left" disclosure={expanded ? 'up' : 'down'} onClick={() => setExpanded(!expanded)}>
            {expanded ? 'Less' : 'More'}
          </Button>
        </div>
      </div>
    </>
  );
};

export default memo(Template);
